import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledWalletSectionUxlError = styled.div`
  width: 100%;

  .m-message-inline {
    padding: ${toRem(16)};
    box-sizing: border-box;

    @media ${baseVariables.mediaQuery.xl} {
      padding: ${toRem(24)};
    }
  }

  .m-message-content {
    font-weight: ${baseVariables.font.fontWeightRegular};

    strong,
    b {
      font-weight: ${baseVariables.font.fontWeightMedium};
    }
  }
`;
